import React from 'react';
import './AboutPage.css';
import CompanyHistory from '../components/about/CompanyHistory';
import MissionVision from '../components/about/MissionVision';
import FounderNote from '../components/about/FounderNote';

const AboutPage = () => {
  return (
    <div className="about-page">
      <section className="about-page-header">
        <div className="page-header-container">
            <div className="container">
            <h1 className="page-title">
                <span className="highlight">About</span> Us
            </h1>
            <p className="page-subtitle">
                Over 30 years of excellence in precision tool manufacturing for industries worldwide
            </p>
            </div>
        </div>
      </section>

      <div className="container">
        <CompanyHistory />
        <MissionVision />
        <FounderNote />
      </div>
    </div>
    
  );
};

export default AboutPage;
